import { default as Skeleton } from 'antd/es/skeleton';
import cn from 'classnames';
import { useMemo } from 'react';

import { C2C_WIDGET_BASE_URL, TENANT } from 'constants/environment';

type Props = {
  endpoint: string;
  token: string | undefined;
  className?: string;
};

export const C2CCryptoIframe = ({ endpoint, token, className }: Props) => {
  const url = useMemo(
    () =>
      `${C2C_WIDGET_BASE_URL}/#/${endpoint}?partner=${TENANT.toUpperCase()}&customerType=LEGAL_PERSON&token=${token}`,
    [token, endpoint]
  );

  if (token === undefined) return <Skeleton />;

  return <iframe src={url} className={cn('h-[40rem] w-full', className)} />;
};
